<ion-item button (click)="openDetail.emit(item)">
  <div slot="start">
    @if (item.isSmartCluster) {
      <ion-icon [src]="clusterIcon"></ion-icon>
    } @else {
      <ion-icon [name]="clusterIcon"></ion-icon>
    }
  </div>
  <ion-label class="ion-text-wrap item-label">
    <h3 class="item-label__title">
      <span class="skeleton">{{ item.title }}</span>
    </h3>
  </ion-label>
</ion-item>
